import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Banner } from '../../shared/models/banner';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { AuthorizationService } from '../authorization/authorization.service';

@Component({
  selector: 'app-banner-edit-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  templateUrl: './banner-edit-dialog.component.html',
  styleUrls: ['./banner-edit-dialog.component.scss']
})
export class BannerEditDialogComponent {
  bannerCopy: { [key: string]: any };
  isSaving = false;

  constructor(
    public dialogRef: MatDialogRef<BannerEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { banner: Banner },
    private auth: AuthorizationService
  ) {
    // Create a deep copy to avoid modifying original data until save
    this.bannerCopy = { ...data.banner };
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.isSaving = true;
    
    // Call auth.saveBannerData for edited row
    this.auth.saveBannerData([this.bannerCopy]).subscribe({
      next: (response) => {
        console.log('Banner saved successfully', response);
        this.isSaving = false;
        this.dialogRef.close(this.bannerCopy);
      },
      error: (error) => {
        console.error('Error saving banner', error);
        this.isSaving = false;
      }
    });
  }
}
